import React, { FC } from 'react';
import { useField } from 'formik';
import MaterialInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { FormHelperText, InputProps } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface Props extends InputProps {
  name: string;
  label: string;
}
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      border: 'none',
      opacity: (props: InputProps) => `${props.disabled ? 0.5 : 1}`,
    },
    inputLabel: {
      paddingLeft: 10,
      paddingTop: 5,
    },
  }),
);

const FormikInput: FC<Props> = ({ name, label, ...other }) => {
  const [field, meta, helpers] = useField(name);
  const classes = useStyles();
  const isError: string = meta.touched && meta.error;
  return (
    <>
      <FormControl className={classes.root}>
        <InputLabel shrink={true} className={classes.inputLabel}>
          {label}
        </InputLabel>
        <MaterialInput error={!!isError} fullWidth {...field} {...other} />
      </FormControl>
      {isError && <FormHelperText error={!!isError}>{isError}</FormHelperText>}
    </>
  );
};

export default FormikInput;
